import React, { FC } from 'react';
import { Form, Input, InputNumber } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { replaceCommaWithPeriod, rules } from 'common/helpers';
import { Modal } from 'common/components';
import { PRICE_LIMIT } from 'common/config';
import { renderRequiredMark } from 'common/helpers/form.helper';
import { ICreateGoodPayload } from 'entities/Goods/Goods.models';

interface IComponentProps {
  open: boolean;
  loading: boolean;
  onCancel: () => void;
  onSubmit: (payload: ICreateGoodPayload) => void;
}

export const CreateGoodsModal: FC<IComponentProps> = ({ open, loading, onCancel, onSubmit }) => {
  const [form] = useForm();

  const handleCancel = (): void => {
    onCancel();
    form.resetFields();
  };

  const handleSubmit = (values: ICreateGoodPayload): void => {
    onSubmit({ ...values, onSuccess: handleCancel });
  };

  return (
    <Modal
      open={open}
      loading={loading}
      width={480}
      cancel={{ title: 'Назад', onClick: handleCancel }}
      submit={{ title: 'Далее', onClick: form.submit }}
    >
      <div className="mb-3 ff-medium fs-m">Новый товар</div>

      <div className="mb-6 ff-regular fs-xs color-dark-grey">
        Укажите информацию о позиции. После завершения товар будет виден в быстром поиске как добавленный вручную.
      </div>

      <Form form={form} layout="vertical" requiredMark={renderRequiredMark} onFinish={handleSubmit}>
        <Form.Item label="Наименование товара" name="name" rules={[rules.required()]}>
          <Input placeholder="Введите наименование" />
        </Form.Item>

        <Form.Item label="Артикул" name="sellerCode" rules={[rules.required()]}>
          <Input placeholder="Введите артикул" />
        </Form.Item>

        <Form.Item label="Характеристики товара" name="description" rules={[rules.required()]}>
          <Input.TextArea className="textarea" placeholder="Укажите характеристики товара через запятую" rows={3} />
        </Form.Item>

        <Form.Item label="Цена за шт (без учета доставки)" name="price" rules={[rules.required()]}>
          <InputNumber
            placeholder="0.00"
            max={PRICE_LIMIT}
            suffix="₽"
            controls={false}
            precision={2}
            parser={replaceCommaWithPeriod}
            formatter={replaceCommaWithPeriod}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
